import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { InvalidationTag } from './api/utils';
/**
 * Restituisce una funzione che invalida la query del Customer in React Query.
 * Usata per forzare un refetch del JWT customer config (es. al cold start
 * dell'app o al ritorno in foreground), così l'app rileva nuove feature flag
 * o aggiornamenti dello schema config emessi dal backend durante la sessione.
 */
export var useInvalidateCustomerCache = function () {
    var queryClient = useQueryClient();
    return useCallback(function () {
        queryClient.invalidateQueries([InvalidationTag.Customer]);
    }, [queryClient]);
};
